import React from 'react';

interface AlertBadgeProps {
  count: number;
  severity?: 'critical' | 'warning' | 'info';
  className?: string;
}

export function AlertBadge({ count, severity = 'critical', className = '' }: AlertBadgeProps) {
  if (count === 0) return null;

  const bgColor =
    severity === 'critical' ? 'bg-red-500' :
    severity === 'warning' ? 'bg-yellow-500' :
    'bg-orange-500';
  const textColor = 'text-white';

  return (
    <span
      className={`inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 rounded-full text-xs font-semibold ${bgColor} ${textColor} ${className}`}
    >
      {count > 99 ? '99+' : count}
    </span>
  );
}
